import { createSelector, Selector } from "reselect";
import { RootState } from "../../store";

export const metadataSelector: Selector<RootState, RootState["metadata"]> = (state) => state.metadata;

export const badgePrintFormatSelector = createSelector(metadataSelector, metadata => metadata.badgePrintFormat);

export const offlineSelector = createSelector(metadataSelector, metadata => metadata.offline);

